export const HUBSPOT_SUPPORT_URL = "https://support.engineears.com/";
